module.exports = __webpack_public_path__ + "static/media/Paloma Ave, Burlingame, CA9.232bd278.jpg";